import { registerComponent, asyncRequest, loading } from "helpers";
import WYATTElement from "wyatt";

registerComponent(
  "swatch-link",
  class SwatchLink extends WYATTElement {
    constructor() {
      super();

      this.productSummary = this.closest(".product-summary");
      this.link = this.querySelector("a");

      this.link.addEventListener("click", this.handleClick.bind(this));
    }

    handleClick(event) {
      event.preventDefault();

      loading.add(this.productSummary);

      this.getProductSummary();
    }

    async getProductSummary() {
      const response = await asyncRequest(`${this.config.url}&view=summary`);

      if (response) {
        this.handleSuccessfulUpdate(response);
      } else {
        window.location.href = this.config.url;
      }
    }

    handleSuccessfulUpdate(html) {
      this.productSummary.outerHTML = html;
    }
  },
);
